import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  BullhornDepartment,
  BullhornPrivateLabelId,
  BullhornUserRestrictionsService,
  BullhornUserType,
} from 'bullhorn-user-restrictions-service-lib';
import { FilterState } from 'user-restrictions-filter-lib';

@Component({
    selector: 'app-bullhorn-user-restrictions',
    templateUrl: './bullhorn.user-restrictions.component.html',
    styleUrls: ['./bullhorn.user-restrictions.component.scss'],
    standalone: false
})
export class BullhornUserRestrictionsComponent implements OnInit {
  @Input()
  filtersFormArray: UntypedFormArray;

  userTypeFilterState: FilterState<BullhornUserType>;
  departmentFilterState: FilterState<BullhornDepartment>;
  privateLabelFilterState: FilterState<BullhornPrivateLabelId>;

  private static USER_TYPE_ENTITY_PATH_ARRAY = ['bullhorn', 'CorporateUser', 'userType', 'id'];
  private static DEPARTMENT_ENTITY_PATH_ARRAY = ['bullhorn', 'CorporateUser', 'departments', 'data', 'id'];
  private static PRIVATELABEL_ENTITY_PATH_ARRAY = ['bullhorn', 'Settings', 'privateLabelId', 'id'];

  constructor(private bullhornUserRestrictionsService: BullhornUserRestrictionsService) {}

  ngOnInit() {
    this.bullhornUserRestrictionsService.getUserTypes().subscribe({
      next: (value) => {
        this.userTypeFilterState = {
          formGroup: this.getOrCreateFormGroup(BullhornUserRestrictionsComponent.USER_TYPE_ENTITY_PATH_ARRAY),
          srcList: value,
        };
      },
    });

    this.bullhornUserRestrictionsService.getDepartments().subscribe({
      next: (value) => {
        this.departmentFilterState = {
          formGroup: this.getOrCreateFormGroup(BullhornUserRestrictionsComponent.DEPARTMENT_ENTITY_PATH_ARRAY),
          srcList: value,
        };
      },
    });

    this.bullhornUserRestrictionsService.getPrivateLabels().subscribe({
      next: (value) => {
        this.privateLabelFilterState = {
          formGroup: this.getOrCreateFormGroup(BullhornUserRestrictionsComponent.PRIVATELABEL_ENTITY_PATH_ARRAY),
          srcList: value,
        };
      },
    });
  }

  private getOrCreateFormGroup(findPath: string[]): UntypedFormGroup {
    const found = this.findFormGroup(findPath);

    if (found) {
      return found;
    }

    const newFormGroup = new UntypedFormGroup({
      entityPath: new UntypedFormControl(findPath),
      filterValues: new UntypedFormControl([]),
      operator: new UntypedFormControl('ANY_MATCH'),
      filterType: new UntypedFormControl('USER'),
    });

    this.filtersFormArray.push(newFormGroup);

    return newFormGroup;
  }

  private findFormGroup(findPath: string[]): UntypedFormGroup | undefined {
    const dottedPath = findPath.join('.');

    return this.filtersFormArray.controls.find((control) => {
      const formGroup = control as UntypedFormGroup;
      const fieldPathArray = formGroup.get('entityPath').value as string[];
      return fieldPathArray.join('.') === dottedPath;
    }) as UntypedFormGroup;
  }
}
